import { render, staticRenderFns } from "./matchCellRenderer.vue?vue&type=template&id=2a807586&lang=html"
import script from "./matchCellRenderer.vue?vue&type=script&lang=js"
export * from "./matchCellRenderer.vue?vue&type=script&lang=js"
import style0 from "./matchCellRenderer.vue?vue&type=style&index=0&id=2a807586&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports